export default __webpack_public_path__ + "assets/images/0086c2eeb2a3249a2c60d4af8de5e843.png";